import { Template } from "../../template/Template.js";
import { prefillTemplate } from "../../template/prefillTemplate.js";
import { INCOMING_VAT_INVOICE } from "./IncomingVatInvoice.js";

export const PHONE_INVOICE: Template = prefillTemplate(
  INCOMING_VAT_INVOICE,
  "2746bcad-5775-479f-9e51-ca8c33214b5a",
  "Tele2 arve (telefon)",
  [
    {
      name: "Title",
      value: "Tele2 arve"
    }
  ]
);
